"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllIcons = exports.Icon = void 0;
// external
const react_router_dom_1 = require("react-router-dom");
const React = require("react");
// local
const colors_1 = require("../../../../types/colors");
const standardSizes_1 = require("../../../../types/standardSizes");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "");
const IconWrapper = ({ to, className, onClick, children }) => {
    if (to && onClick) {
        throw new Error("Cannot provide both 'onClick' & 'to' props to Icon component.");
    }
    if (to) {
        return (React.createElement(react_router_dom_1.NavLink, { to: to, className: className, "data-test": "icon" }, children));
    }
    else {
        return (React.createElement("span", { className: className, onClick: onClick
                ? function (e) {
                    e.stopPropagation();
                    onClick.call(this, e);
                }
                : null, "data-test": "icon" }, children));
    }
};
const Icon = ({ name, children, to, className = "", size = "", animate = "", onClick, subtle = false, variant = colors_1.TColorVariants.None }) => {
    const fontClass = css("Icon", `icon-${name}`, `-size-${size}`, `-color-${variant}`, animate, {
        "-clickable": !!onClick,
        "-subtle": subtle,
        className
    });
    return (React.createElement(IconWrapper, { "data-test": "icon", className: fontClass, onClick: onClick || null, to: to }, React.Children.map(children, child => {
        if (child.type !== exports.Icon) {
            throw new Error("Only one Icon component allowed as child");
        }
        return (React.createElement("div", { className: css("icon_childIcon"), "data-test": "child-icon" }, child));
    })));
};
exports.Icon = Icon;
const AllIcons = () => Object.keys(styles).map((iconClass, i) => {
    if (!iconClass.match(/^icon-/)) {
        return null;
    }
    const name = iconClass.replace(/^icon-/, "");
    return (React.createElement("div", { key: i, style: {
            display: "inline-block",
            fontSize: "8pt",
            margin: "0 32px 32px 0",
            textAlign: "center"
        } },
        React.createElement(exports.Icon, { name: name, size: standardSizes_1.TStandardSizes.Large }),
        React.createElement("div", { style: { marginTop: "8px" } }, name)));
});
exports.AllIcons = AllIcons;
//# sourceMappingURL=index.js.map